/**
 * CBD HUT — Featured Products (native slider micro enhancements)
 *
 * Adds small “premium” touches on top of Shopify's built-in slider-component:
 * - Progress bar fill (based on slider counter current/total)
 * - Edge-fade masking (removes fade at the start/end)
 * - Auto-hide controls when the track can't scroll
 *
 * Works with the native slider implementation in Refresh/Dawn (assets/global.js).
 * Hooks onto: [data-cbh-featured-products]
 */
(function () {
  'use strict';

  if (window.CBH_FEATURED_PRODUCTS_MICRO) return;
  window.CBH_FEATURED_PRODUCTS_MICRO = true;

  var instances = new Set();
  var resizeTimer = null;

  function toInt(v, fallback) {
    var n = parseInt(String(v || ''), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function initOne(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cbhFpMicroInit === '1') return;
    sectionEl.dataset.cbhFpMicroInit = '1';

    var track =
      sectionEl.querySelector('ul[id^="Slider-"].slider') ||
      sectionEl.querySelector('ul[id^="Slider-"]') ||
      sectionEl.querySelector('.slider');

    // Cached measurements to avoid forced reflow during scroll
    var cachedMaxScroll = 0;
    var cachedCanScroll = false;
    var _measureRaf = null;

    function measure() {
      // Read layout in one place
      var sw = track.scrollWidth || 0;
      var cw = track.clientWidth || 0;
      cachedCanScroll = sw > cw + 2;
      cachedMaxScroll = Math.max(0, sw - cw);
    }

    function scheduleMeasure() {
      if (_measureRaf) cancelAnimationFrame(_measureRaf);
      _measureRaf = requestAnimationFrame(function () {
        _measureRaf = null;
        measure();
        updateEdges();
        updateProgress();
        updateControls();
      });
    }

    var buttons = sectionEl.querySelector('.slider-buttons');
    var currentEl = sectionEl.querySelector('.slider-counter--current');
    var totalEl = sectionEl.querySelector('.slider-counter--total');
    var bar = sectionEl.querySelector('[data-fp-progress-bar]');

    if (!track || !buttons || !currentEl || !totalEl) return;

    function canScroll() { return cachedCanScroll; }

    function maxScroll() { return cachedMaxScroll; }

    function atStart() {
      return track.scrollLeft <= 2;
    }

    function atEnd() {
      return track.scrollLeft >= maxScroll() - 2;
    }

    function updateEdges() {
      // Hide controls entirely if no scrolling is possible
      var scrollable = canScroll();
      buttons.hidden = !scrollable;

      // Edge fade: remove fade when we're at either end
      track.style.setProperty('--fp-mask-left', atStart() ? '0px' : '24px');
      track.style.setProperty('--fp-mask-right', atEnd() ? '0px' : '24px');
    }

    function updateProgress() {
      if (!bar) return;

      var total = toInt(totalEl.textContent, 0);
      var current = toInt(currentEl.textContent, 1);

      current = clamp(current, 1, Math.max(1, total));
      var pct = total > 1 ? ((current - 1) / (total - 1)) * 100 : 0;
      bar.style.width = pct + '%';
    }

    // Observe counter text changes (slider-component updates these)
    var mo = new MutationObserver(function () {
      updateProgress();
      updateEdges();
    });

    mo.observe(currentEl, { characterData: true, childList: true, subtree: true });
    mo.observe(totalEl, { characterData: true, childList: true, subtree: true });

    // Respond to manual scroll / drag
    track.addEventListener('scroll', function () {
      updateEdges();
    }, { passive: true });

    // Store for global resize refresh
    instances.add({ sectionEl: sectionEl, updateEdges: updateEdges, updateProgress: updateProgress });

    // Initial sync (and again after layout settles)
    measure();
    updateProgress();
    updateEdges();
    window.requestAnimationFrame(function () {
      updateProgress();
      updateEdges();
    });
    window.addEventListener('load', function () {
      updateProgress();
      updateEdges();
    }, { once: true });
  }

  function initAll(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-cbh-featured-products]');
    if (!nodes || !nodes.length) return;
    nodes.forEach(initOne);
  }

  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      instances.forEach(function (inst) {
        try {
          inst.updateProgress();
          inst.updateEdges();
        } catch (e) {}
      });
    }, 120);
  }

  window.addEventListener('resize', onResize);

  function scheduleInitAll() {
  var started = false;
  var start = function () {
    if (started) return;
    started = true;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function(){ scheduleInitAll(); }, { timeout: 2500 });
    } else {
      setTimeout(function(){ scheduleInitAll(); }, 300);
    }
  };

  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll('[data-cbh-featured-products-micro], slider-component');
    if (els && els.length) {
      var io = new IntersectionObserver(function (entries) {
        for (var i=0;i<entries.length;i++){
          if (entries[i].isIntersecting) { io.disconnect(); start(); break; }
        }
      }, { rootMargin: '300px 0px' });
      for (var j=0;j<els.length;j++){ io.observe(els[j]); }
      // fallback
      setTimeout(start, 2800);
      return;
    }
  }
  start();
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleInitAll(); });
  } else {
    scheduleInitAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();